import { render } from "./Myvideo.vue?vue&type=template&id=775abdf9&scoped=true"
import script from "./Myvideo.vue?vue&type=script&lang=js"
export * from "./Myvideo.vue?vue&type=script&lang=js"

import "./Myvideo.vue?vue&type=style&index=0&id=775abdf9&lang=scss&scoped=true"

import exportComponent from "/apps/srv/jenkins/workspace/feihua_fe_mguoxueweb_online/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-775abdf9"]])

export default __exports__